import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getWarnInfos, selectWarnInfos } from '../../redux/aiReducer';
import WarnDetail from './detail';

const Warn = () => {
  const dispatch = useDispatch();
  const warnInfos = useSelector(selectWarnInfos);

  useEffect(() => {
    dispatch(getWarnInfos());
  }, [dispatch]);

  return (
    <div className="mt-2">
      <h1 className="font-extrabold text-red-500 text-[20px] mb-2">Warning detail</h1>
      <p className="text-xs text-gray-500 mb-4">
        Matches found on monitored auction sites after scans run.
      </p>
      {warnInfos.length === 0 ? (
        <p className="text-sm text-gray-500 py-8 border border-dashed border-gray-200 rounded-lg">
          No auction-site warnings yet. Warnings appear when scan results match a tracked auction URL.
        </p>
      ) : (
        warnInfos.map((item) => <WarnDetail key={item._id || item.artworkId?._id} info={item} />)
      )}
    </div>
  );
};

export default Warn;
